var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"obi-dropdown-item"},[_c('a',_vm._b({staticClass:"dropdown-item",class:[_vm.wrapClass]},'a',_vm.attrs,false),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }